export default __webpack_public_path__ + "static/scale-f24d3f9f8a36d5a269a930840cdefade.png";